import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var ModalOverlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  z-index: ", ";\n  background: ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n\n  padding: ", "px;\n  @media (min-width: ", "px) {\n    padding: ", "px;\n  }\n"], ["\n  display: flex;\n  z-index: ", ";\n  background: ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n\n  padding: ", "px;\n  @media (min-width: ", "px) {\n    padding: ", "px;\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.zIndex.modal;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.darkOverlay;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs;
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.xs;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.lg;
});
var ModalContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  ", ";\n  max-width: 100%;\n  max-height: 100vh;\n  padding: ", "px;\n  border-radius: ", "px;\n  @media (min-width: ", "px) {\n    padding: ", "px;\n    width: 100%;\n    max-width: ", ";\n    max-height: 90vh;\n  }\n"], ["\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  ", ";\n  max-width: 100%;\n  max-height: 100vh;\n  padding: ", "px;\n  border-radius: ", "px;\n  @media (min-width: ", "px) {\n    padding: ", "px;\n    width: 100%;\n    max-width: ", ";\n    max-height: 90vh;\n  }\n"])), function (props) {
  return props.background && "background: ".concat(props.background);
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.md;
}, function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius.small;
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.xs;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.lg;
}, function (props) {
  var _a, _b;

  return props.maxWidth ? props.maxWidth : props.isConfirm ? ((_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.modalConfirmMaxWidth) + 'px' : ((_b = props.theme.constants) === null || _b === void 0 ? void 0 : _b.modalContainerMaxWidth) + 'px';
});
var ModalHeaderContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-bottom: ", "px;\n  @media (min-width: ", "px) {\n    padding-top: 8px;\n  }\n"], ["\n  padding-bottom: ", "px;\n  @media (min-width: ", "px) {\n    padding-top: 8px;\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.md;
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.sm;
});
var ModalHeader = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: ", "px;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: ", "px;\n  align-items: center;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.sm;
});
var CloseButtonWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var ChildrenWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  min-height: 64px;\n  gap: ", "px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  min-height: 64px;\n  gap: ", "px;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.md;
});
var FooterWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  gap: ", "px;\n"], ["\n  display: flex;\n  gap: ", "px;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
export { ChildrenWrapper, CloseButtonWrapper, FooterWrapper, ModalContainer, ModalHeader, ModalHeaderContainer, ModalOverlay };